import { AxiosRequestConfig } from 'axios';

import { Client } from '../Client';

export class OnescoreClient extends Client {
    constructor(requestConfig: AxiosRequestConfig) {
        super(requestConfig);
    }

    public getProcessId = async (params: {
        data: {
            personNumber: string;
            phoneNumber: string;
            gjeldsConsent: boolean;
        };
    }) => {
        return this.client
            .post<{
                processId: string;
            }>(`/finance-data-process`, params.data)
            .then((response) => response.data.processId);
    };

    public getLoanData = async (params: { processId: string }) => {
        return this.client
            .get<any>(`/loan_applications/${params.processId}`)
            .then((response) => response.data);
    };
}
